import { type ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ClientOnly } from "@/components/ClientOnly";
import { CookieConsentBanner } from "@/components/CookieConsentBanner";
import { PageMeta } from "@/components/PageMeta";

const queryClient = new QueryClient();

export function RootLayout() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <PageMeta />
          <ScrollToTop />
          <Outlet />
          <ClientOnly>
            <CookieConsentBanner />
          </ClientOnly>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
